
export const isEmpty = value => {
    return value === '' || value === null || value === undefined
}

export const isNonEmpty = value => {
    return !isEmpty(value)
}